<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-login></create-login>
    </div>
  </div>
</template>

<script>
import CreateLogin from "../../components/CreateLogin.vue";

export default {
  components: {
    CreateLogin
  },
  name: "Login",
  data() {
    return {
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
